import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Copyright } from "lucide-react";
import NextLink from "next/link";
import Logo from "./global/Logo";
//import LogoZOHO from "./global/LogoZOHO";

import { footer } from "@/config/footer";

const Footer = () => {
  return (
    <footer className="footer bg-black-charcoal text-text-light py-10">
      <div className="container mx-auto px-4">
        
        <div className="grid gap-6 grid-cols-12 border-b border-gray-200 pb-10">

          <div className="col-span-full lg:col-span-4">
            <Logo />
            <p className="my-3 text-xs text-gray-light">{footer.summary}</p>
            <div className="space-y-2">
              {footer.contacts.map((item, i) => {
                const Icon = item.icon;
                return (
                  <div key={i} className="flex items-center gap-1">
                    <Icon className="w-4 h-4 text-gray-light" />
                    <p className="text-xs text-gray-light">{item.label}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {footer.navigation.map((item, i) => (
            <div key={i} className="col-span-full lg:col-span-2">
              <h2 className="font-semibold text-base text-gray-light">{item.title}</h2>
              <div className="flex flex-col gap-3 py-2">
                {item.links.map((link, i) => (
                  <NextLink key={i} href={link.path} passHref>
                    <div className="next-link text-xs text-gray-dark cursor-pointer hover:text-green-light">
                      {link.title}
                    </div>
                  </NextLink>
                ))}
              </div>
            </div>
          ))}
{/*           <LogoZOHO /> */}
        </div>

        <div className="py-3 flex justify-between items-center space-y-1 flex-wrap text-xs text-gray-light">
          <div className="flex items-center space-x-2">
            <Copyright className="w-5 h-5" />
            <span>{new Date().getFullYear()}</span>
            <span>SICONS PERU - All Rights Reserved</span>
          </div>
          <div className="flex items-center space-x-2 space-y-1 flex-wrap">
            <NextLink href="#" passHref>
              <div className="next-link text-xs text-gray-dark cursor-pointer hover:text-green-light">Terms and Conditions</div>
            </NextLink>
            <NextLink href="#" passHref>
              <div className="next-link text-xs text-gray-dark cursor-pointer hover:text-green-light">Privacy Policy</div>
            </NextLink>
            <NextLink href="#" passHref>
              <div className="next-link text-xs text-gray-dark cursor-pointer hover:text-green-light">Cookie Policy</div>
            </NextLink>
          </div>

          <div className="flex items-center gap-4">
            {footer.socialMedia.map((item, i) => (
              <NextLink key={i} href={item.url} passHref>
                <div className={`social-icon ${item.name}`}>
                    <FontAwesomeIcon icon={item.icon} />
                </div>                  
              </NextLink>
            ))}
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
